import { render, staticRenderFns } from "./ProfileCategories.vue?vue&type=template&id=903483b4"
import script from "./ProfileCategories.vue?vue&type=script&lang=js"
export * from "./ProfileCategories.vue?vue&type=script&lang=js"
import style0 from "./ProfileCategories.vue?vue&type=style&index=0&id=903483b4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports